import api from './api'

export const setting = {
  aliPayISVPageList: (params) => {
    return api.post(`/CloudParkAPI/Setting/AliPayISVPageList`, params)
  },
  aliPayISVPageInfo: (id) => {
    return api.get(`/CloudParkAPI/Setting/AliPayISVInfo/${id}`)
  },
  aliPayISVEdit: (params) => {
    return api.post(`/CloudParkAPI/Setting/AliPayISVEdit`, params)
  },
  aliPayISVList: () => {
    return api.get(`/CloudParkAPI/Setting/AliPayISVList`)
  }
}



// WEBPACK FOOTER //
// ./src/api/setting.js